<template>
  <button type="button" class="c-heart" :class="[buttonType]">
    <i
      :class="['c-heart__icon', iconClass, size, buttonType, { isFavourite }]"
      @click.stop.prevent="onClick"
    ></i>
  </button>
</template>

<script>
import { isLogin } from '~/js/templates/index/helpers'
import {
  FavouriteService,
  FAVORITE_TYPE,
  FAVORITE_OPERATIONS,
} from '~/js/services/favouriteService'
import { pushFavoriteEvent } from '~/js/gtm'

const CLASS_NAME_HEART_FILLED = 'icon-heart-filled'
const CLASS_NAME_HEART_OUTLINE = 'icon-heart-outline'

export default {
  name: 'ComponentHeart',
  props: {
    handle: { type: String, required: true, default: '' },
    id: { type: [Number, String], required: true, default: '' },
    isFavourite: { type: Boolean, default: false },
    size: { type: String, default: '' },
    type: { type: String, default: Object.keys(FAVORITE_TYPE)[0] },
    buttonType: { type: String, default: '' },
  },
  computed: {
    iconClass() {
      return isLogin && this.isFavourite
        ? CLASS_NAME_HEART_FILLED
        : CLASS_NAME_HEART_OUTLINE
    },
  },
  methods: {
    onClick() {
      if (!isLogin) {
        window.dispatchEvent(new CustomEvent('button-login-required-clicked'))
        return
      }

      const type = FAVORITE_TYPE[this.type]
      if (this.isFavourite) {
        this.$emit('heart-changed', false)
        pushFavoriteEvent({
          handle: this.handle,
          type: this.type,
          operation: FAVORITE_OPERATIONS.REMOVE,
        })
        FavouriteService.removeFavorite(this.handle, type).fail((err) => {
          this.$emit('heart-changed', true)
          console.error(err)
        })
      } else {
        this.$emit('heart-changed', true)
        pushFavoriteEvent({
          handle: this.handle,
          type: this.type,
        })
        FavouriteService.addFavorite(this.handle, type).fail((err) => {
          this.$emit('heart-changed', false)
          console.error(err)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';
@use '~/scss/generic/mixins';

.c-heart {
  line-height: 1;
  flex-shrink: 0;

  &.round {
    background-color: #fff;
    border: 1px solid variables.$color-brown;
    border-radius: 24px;
    font-size: 1.1em;
    line-height: 46px;
    text-align: center;
    width: 48px;
  }

  &__icon {
    color: variables.$color-heart;
    transition: 0.3s;
    line-height: 1;
    font-size: 20px;

    @include mixins.screen-mobile {
      font-size: 18px;
    }

    &.large {
      font-size: 20px;

      @include mixins.screen-desktop {
        font-size: 24px;
      }
    }

    &.round {
      position: relative;
      top: 1px;
      color: variables.$color-brown;
    }

    &:hover {
      @include mixins.screen-desktop {
        opacity: 0.6;
      }
    }
  }
}
</style>
